import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=5fa266b4&scoped=true&"
import script from "./PartnerList.vue?vue&type=script&lang=js&"
export * from "./PartnerList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerList.vue?vue&type=style&index=0&id=5fa266b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa266b4",
  null
  
)

export default component.exports